// extracted by mini-css-extract-plugin
module.exports = {"slides":"PageCountCarousel_slides__GPNEb"};